export { IdbFallbackReason } from './IdbFallbackReason';
export type { IdbFallbackResult } from './IdbFallbackResult';
export { isIdbFallbackResult, isIdbNotSupportedResult } from './isIdbFallbackResult';
export { idbNotSupportedResult } from './idbNotSupportedResult';
